import { render, staticRenderFns } from "./RiskDiagnosisPage.vue?vue&type=template&id=69aac1a6"
import script from "./RiskDiagnosisPage.vue?vue&type=script&lang=js"
export * from "./RiskDiagnosisPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports